export const notificationSchema = {
  today: [],
  yesterday: [],
  older: [],
  unreadCount: 0,
};
